let membershipCheckbox = document.getElementById('cherryClub');
let newsletterCheckbox = document.getElementById('newsletter');
let promoProfileUpdateForm = document.querySelector('.account-main__promo-block-form-element');

if(!membershipCheckbox || !newsletterCheckbox || !promoProfileUpdateForm) return;

let btn = document.querySelector('.account-main__promo-block-submit');

function checkboxCheck(){
  if ( membershipCheckbox.checked && newsletterCheckbox.checked ) {
      btn.disabled = false;          
  } else {
      btn.disabled = true; 
  }
}

window.addEventListener("load", ()=>{ 
    checkboxCheck();          
    membershipCheckbox.addEventListener('change', function() {
        checkboxCheck();
    });    
    newsletterCheckbox.addEventListener('change', function() {
        checkboxCheck();
    });      
});

if(promoProfileUpdateForm) {
  // Add an event listener for form submission
  promoProfileUpdateForm.addEventListener("submit", function(event) {
    // Prevent the default form submission
    event.preventDefault();

    if(membershipCheckbox.checked && newsletterCheckbox.checked) {

      const makeApiRequest = (url, data) => {
        return fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
      };
        
      const updateMarketingPermissionUrl = `https://konges-sloejd-middleman.vercel.app/api/update-marketing-permission/${theme.customer_club.store}`;
      const updateCustomerClubUrl = `https://konges-sloejd-middleman.vercel.app/api/update-customer-club/${theme.customer_club.store}`;
        
      const marketingRequestData = {
        customer: window.customer.id,
        email: window.customer.email,
        status: newsletterCheckbox.checked,
      };
      
      const customerClubRequestData = {
        customer: window.customer.id,
        email: window.customer.email,
        status: membershipCheckbox.checked,
      };
        
      Promise.all([
        makeApiRequest(updateMarketingPermissionUrl, marketingRequestData),
        makeApiRequest(updateCustomerClubUrl, customerClubRequestData),
      ])
      .then(() => {
        location.reload();
      });
    }
  });
}
